import TagComponent from "./Tag";
import Badge from "./components/Badge/TagBadge";
import ButtonInline from "./components/ButtonInline/TagButtonInline";
import Counter from "./components/Counter/TagCounter";
import Icon from "./components/Icon/TagIcon";
import Label from "./components/Label/TagLabel";
import LeftAddon from "./components/LeftAddon/LeftAddon";

interface ITagExtensions {
    Icon: typeof Icon;
    Counter: typeof Counter;
    LeftAddon: typeof LeftAddon;
    Label: typeof Label;
    Badge: typeof Badge;
    ButtonInline: typeof ButtonInline;
}

export const Tag: typeof TagComponent & ITagExtensions = Object.assign(
    TagComponent,
    {
        Icon,
        Counter,
        LeftAddon,
        Label,
        Badge,
        ButtonInline,
    },
);

export type { TagProps } from "./Tag";

export * from "./presets";
